import { useEffect } from 'react'
import { useBirthdayStore } from './birthdayStore'

/** Load today's birthday set once authenticated; refresh every 6h (catches date rollover). */
export function useBirthdayBoot(isAuthenticated: boolean) {
  const loadToday = useBirthdayStore(s => s.loadToday)
  useEffect(() => {
    if (!isAuthenticated) return
    loadToday()
    const id = setInterval(loadToday, 6 * 60 * 60 * 1000)
    return () => clearInterval(id)
  }, [isAuthenticated, loadToday])
}
